var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"step-nav",class:{
    'step-nav--normal': _vm.step < _vm.index,
    'step-nav--selecting': _vm.step === _vm.index,
    'step-nav--complete': _vm.step > _vm.index,
  },on:{"click":_vm.clickHandler}},[_c('span',{staticClass:"step-nav--heading--step"},[_vm._v("STEP "+_vm._s(_vm.index + 1))]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }